import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent implements OnInit {

	countryForm:any;
	pager: any = {};
	pagedItems: any[];
	// countrycode: any;
	total: any;
	limit: any;
	pageNo: any;
	countryList:any;
	countrycodeList:any;
	selectedCountry:any;
	modalTitle:any;
	btnTitle:any;
	isActivatedDelete:boolean=false;
	isActivatedAdd:boolean=false;
	isActivatedEdit:boolean=false;
	selected_id: string;
	selected_name : string;
	searchStr:any='';
	isCountryAvailable:boolean=true;
	isCountrycodeAvailable:boolean=true;
  constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

  ngOnInit() {
		//this.commonService.setTitle();
		$(".navbar-brand").text("Country");
		this.commonService.process();
		this.pageNo = 1;
		this.limit = 10;

		this.countryForm = new FormGroup({

			countrycode: new FormControl("", Validators.compose([
				Validators.required,
			])),

			country: new FormControl("", Validators.compose([
				Validators.required,
			])),
			
			
			
		});

		this.getCountryList(this.pageNo, this.limit, this.searchStr);
	}

	// Get Country list
	getCountryList = function (pageNo, limit, searchStr){
		        // debugger;;
		this.commonService.process();
		this.authService.getCountry(pageNo, limit, searchStr).subscribe(data=>{
			if(data.success) {
				this.isCountryAvailable=true;
				        // debugger;;
				this.countryList = data.country;
				// this.countrycodeList= data.countrycode;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			
			else{
				this.isCountryAvailable=false;
				this.countryList = [];
				// this.countrycodeList = [];
			}
			
			this.commonService.hideProcess();
			        // debugger;;
		});
	}

	
	// Pagination
	setPage(page: number, param) {

        if (page < 1 || page > this.pager.totalPages) {
            return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

        // get current page of items
		this.pagedItems = this.countryList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if(!param) {
			this.getCountryList(page, this.limit, this.searchStr);
		}
	}

	addCountry = function () {
		this.resetForm();
		this.modalTitle = "Add Country and Code";
		this.btnTitle = "Save";
		this.isActivatedAdd = true;
		this.isActivatedDelete = false;
		this.isActivatedEdit = false;
	}

	// Selected country to be update
	updateSelectedCountry = function(country) {
		this.resetForm();
		this.modalTitle = "Update Country";
		this.btnTitle = "Update";
		this.isActivatedAdd = false;
		this.isActivatedDelete = false;
		this.isActivatedEdit = true;
		this.selectedCountry = country;
		this.countryForm.controls['country'].setValue(country.country);
		this.countryForm.controls['countrycode'].setValue(country.countrycode);
		this.selected_id = country._id;
	}

	// Selected Country to be delete
	deleteSelectedCountry = function(country) {
		this.resetForm();
		this.modalTitle = "Delete Country";
		this.btnTitle = "Delete";
		this.isActivatedDelete = true;
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.selectedCountry = country;
		this.selected_id = country._id;
		this.selected_name= country.country;
	}

	//Reset Form
	resetForm()
	{
		this.countryForm.reset();
		this.selectedCountry = null;
	}

	// Submit ( Add country functionality)
	manageCountry(CountryForm)
	{
		if(this.countryForm.valid && this.isActivatedAdd)
		{	
			this.btnTitle = "Saving...";
			$(':button[type="submit"]').attr('disabled', true);
			this.authService.manageCountry(CountryForm,null, 'add').subscribe(data=>{
				if(data.success) {
					this.getCountryList(1, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				$(':button[type="submit"]').attr('disabled', false);
				this.closeModel();
			});
		}
		else if(this.countryForm.valid && this.isActivatedEdit)
		{	
			this.btnTitle = "Updating...";
			$(':button[type="submit"]').attr('disabled', true);
			this.authService.manageCountry(CountryForm,this.selected_id, 'edit').subscribe(data=>{
				if(data.success) {
					this.getCountryList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				$(':button[type="submit"]').attr('disabled', false);
				this.closeModel();
			});
		}
		else if(this.isActivatedDelete)
		{	
			this.btnTitle = "Deleting...";
			$(':button[type="submit"]').attr('disabled', true);
			this.authService.manageCountry(null,this.selected_id, 'delete').subscribe(data=>{
				if(data.success) {
					this.getCountryList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				$(':button[type="submit"]').attr('disabled', false);
				this.closeModel();
			});
		}
		else{
			this.validationService.validateAllFormFields(this.countryForm);
		}
	}
	closeModel = function()
	{
		$('.close').click();
	}

	// Search language
	searchCountry = function(){
		this.searchStr = jQuery("#search").val();
		this.getCountryList(1, this.limit, this.searchStr);
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/country/country.component.ts